import type { ReactNode } from 'react'
import { forwardRef } from 'react'

import { DatabaseZap } from 'lucide-react'

export const ToolText = forwardRef<HTMLDivElement, { children: ReactNode }>(
  ({ children }, ref) => {
    return (
      <div
        className="gap-x-s p-s flex items-center overflow-hidden whitespace-nowrap rounded-lg border bg-surface-card font-mono text-xs font-medium leading-none"
        ref={ref}
      >
        <DatabaseZap className="size-3 shrink-0 text-secondary" />
        <div className="text-default">{children}</div>
      </div>
    )
  },
)

ToolText.displayName = 'ToolText'
